import React from 'react'
import styles from './scheduleAddCart.module.css'
import { Back, Upload } from '../../../Svg'

const ScheduleAddCart = () => {
    return (
        <>
            <div className={styles.imgBread}>
                <span>Schedule Tool Cart</span>
            </div>
            <div className={styles.scheduleContainer}>
                <div className={styles.bomContentBox}>
                    <h3>Cart : 0 items</h3>
                    <div className={styles.displayFlexBtwn}>
                        <h2>Total</h2>
                        <h2>$0</h2>
                    </div>
                    <div className={styles.displayFlex}>
                        <button className={styles.cancelBtn}>Add More items</button>
                    </div>
                </div>
                <div className={styles.bomTabsCol2}>
                    <p>Note:
                        <ol>
                            <li>You can send the PO to this email <a href='' className={styles.download}>company@electrowiz.com </a> directly.</li>
                            <li> You can view your open order in your <a href='' className={styles.download}> User dashboard </a></li>
                        </ol>
                    </p>

                </div>
            </div>
        </>
    )
}

export default ScheduleAddCart